"use client";
import Image from "next/image";
import { useEffect } from "react";

// Error boundaries must be Client Components

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // Log the error or send it to an error tracking service
    console.error('Global Error:', error);
  }, [error]);
  return (
    // global-error must include html and body tags
    <html>
      <body>
        <div className="font-onest bg-[#1453FF1A] sm:bg-[#fff] min-h-[120vh] ">
          <Image
            src="/hack-logo.png"
            alt="hack the jobs logo"
            width={180}
            height={52}
            className="cursor-pointer mx-auto py-[20px] xm:pb-[0px] xm:px-4"
          />
          <div className="min-h-[70vh] flex justify-center items-center">
            <div className="max-w-[683px] bg-[#fff] rounded-[24px] p-[80px] lg:p-[60px] md:p-[24px]">
              <h2 className="font-bold text-[40px] leading-[130%] tracking-[0] text-center mb-[16px]">
                Oops
              </h2>
              <p className="font-medium text-[18px] leading-[150%] tracking-[0] text-center mb-[64px]">
                Something went wrong
              </p>
              <button
                onClick={() => reset()}
                className="w-[276px] h-[48px] font-medium text-[16px] text-[#fff] leading-[24px] tracking-[0] bg-[#1453FF] py-[12px] px-[20px] rounded-[8px] block mx-auto"
              >
                Please Try Again
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
